module.exports = __webpack_public_path__ + "img/hs-lg2.48400d58.png";